import React from 'react';

import { Switch } from 'react-router';
import { Route } from 'react-router-dom';

import { connect } from 'react-redux';

import PrivateRoute from './components/PrivateRoute';
import router from './routes';

// layout
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import Footer from './components/Footer';

// loading
import Loading from './components/Loading';
// page
import Login from './components/pages/Login';
// error
import Page404 from './components/error/Page404';
import PageNotice from './components/error/PageNotice';
import Page500 from './components/error/Page500';

import NewVersionAvailable from './components/NewVersionAvailable';

function App({ loginState, loadingState, mainJsFilename }) {
  let headerBlock = (<Header />);
  if(!localStorage.getItem('current_store_id')){
    headerBlock = ''
  }
  var functions = [];

  router.forEach((element) => {

    if (localStorage.getItem('current_store_id')==='2' && element.route === '/staffJobList'){
      //分店不顯示職位管理
    }else{
      functions.push(<PrivateRoute
        key={element.name}
        auth={element.auth}
        exact={element.exact}
        path={element.route}
        Component={element.Component}
        />)
    }
});
const pathname = window.location.pathname

if(pathname !== '/Login' &&!localStorage.getItem('current_store_id') && pathname !== '/store'){
   window.location = '/store';
  }
  return (
    <div id="App" className="App">
      {headerBlock}
      <div className="page" style={{ paddingTop: loginState.isLogin && loginState.currentStore? '' : '0px' }}>
        <input type="checkbox" id="toggle-menu" />
        <div className={loginState.isLogin && loginState.currentStore ? 'l-sidebar-box' : 'l-sidebar-box not-Login'}>
          <Sidebar />
        </div>
        <main className="main" style={{ width: !loginState.isLogin || !loginState.currentStore? '100%' : '' ,backgroundColor: loginState.currentStore === '2' ?'#e7eaf2':''}}>
          <Switch>
            <Route path="/login" component={Login} />
            <Route path="/errorPage" component={Page500} />
            <Route path="/pageNotice" component={PageNotice} />
            {
              functions
            }
            <Route component={Page404} />
          </Switch>
          <Footer />
        </main>
      </div>
      <Loading active={loadingState} />
      <NewVersionAvailable mainJsFilename={mainJsFilename} />
    </div>
  );
}

const mapStateToProps = store => ({
  loginState: store.loginState,
  loadingState: store.loading,
});

export default connect(mapStateToProps)(App);
